import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function CoverSection() {
  const scrollToPrice = () => {
    const element = document.getElementById('cta-comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section id="portada" className="min-h-screen relative flex items-center justify-center overflow-hidden bg-cream pt-16 lg:pt-0" data-id="element-241">
      <div className="absolute inset-0 z-0" data-id="element-242">
        <div className="absolute inset-0 bg-gradient-to-r from-cream via-cream/90 to-transparent z-10 lg:w-2/3" data-id="element-243" />
        <div className="absolute inset-0 bg-gradient-to-t from-cream via-transparent to-transparent z-10 lg:hidden" data-id="element-244" />
        <img src="https://cdn.magicpatterns.com/uploads/ofbvoC8zz2yKWkRQT8Y88d/metabolismo_dorado.png" alt="Metabolismo Dorado Cover" className="w-full h-full object-cover object-right lg:object-center opacity-40 lg:opacity-100 mix-blend-multiply" data-id="element-245" />
      </div>

      <div className="relative z-20 container mx-auto px-6 lg:px-16 flex flex-col items-start w-full" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-247">
          <div className="inline-block px-4 py-1.5 mb-6 border border-gold/40 rounded-full bg-cream/50 backdrop-blur-sm" data-id="element-248">
            <span className="text-deepGold font-medium tracking-wide text-sm uppercase" data-id="element-249">
              El Plan Anti-Inflamatorio de 14 Días
            </span>
          </div>

          <h1 className="font-serif text-5xl lg:text-7xl font-bold text-darkBrown leading-tight mb-6" data-id="element-250">
            Metabolismo
            <br data-id="element-251" />
            <span className="text-gold italic" data-id="element-252">Dorado</span>
          </h1>

          <p className="text-xl lg:text-2xl text-darkBrown/80 mb-10 text-balance leading-relaxed" data-id="element-253">
            Recupera tu figura, tu energía y tu bienestar después de los 65.
          </p>

          <button onClick={scrollToPrice} className="bg-gold hover:bg-deepGold text-white px-8 py-4 rounded-full font-medium text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center gap-3" data-id="element-254">
            Comenzar a Leer
            <ChevronDown className="w-5 h-5" data-id="element-255" />
          </button>
        </motion.div>
      </div>
    </section>;
}